import { api } from '../../../lib/api'

export const RESET_PASSWORD_TOKEN_REQUEST = 'RESET_PASSWORD_TOKEN_REQUEST'
export const RESET_PASSWORD_TOKEN_SUCCESS = 'RESET_PASSWORD_TOKEN_SUCCESS'
export const RESET_PASSWORD_TOKEN_FAILED = 'RESET_PASSWORD_TOKEN_FAILED'

export const resetPasswordToken = function (data, onComplete) {
  return function (dispatch) {
    dispatch({
      type:RESET_PASSWORD_TOKEN_REQUEST
    })
    api.resetPasswordToken(data).then(resetPasswordResponse => {
      dispatch({
        type:RESET_PASSWORD_TOKEN_SUCCESS,
        payload: resetPasswordResponse
      })
      if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: RESET_PASSWORD_TOKEN_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile/reset-password-token.js